import React, { Component } from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import withRouter from '../../withRouter'
import SubAccDataTable from './SubAccDataTable'


class SubAccounts extends Component {
    render() {
        return (
            <div>
        <Header />
                <Menu/>
                <>
              <div className="content-wrapper">
              <SubAccDataTable/>
              </div>
              </>
              <Footer/>
            </div>
        )
    }
}
export default withRouter(SubAccounts)